import { Outlet } from "react-router-dom";
import ProjectHeader from "../../components/new/ProjectHeader";
import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { useLayoutStore } from "../../stores/ui.store";

export default function ProjectLayout() {
  const { setLayoutMode } = useLayoutStore();

  useEffect(() => {
    setLayoutMode(
      JSON.parse(localStorage.getItem("layoutMode") || '"default"')
    );
  }, []);

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <ProjectHeader />

      <div className="flex-1 min-h-0 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}
